<template>
    <div class="modal" :class="{active: modal}">
        <div class="modal_dimmer">
            <div class="modal_content">

                <h3 v-if="title !== ''" class="modal_title">{{ title }}</h3>

                <a href="#0" class="closeBtn" @click.prevent="close">
                    <ion-icon name="close-outline"></ion-icon>
                </a>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            modal: false,
            gradients: [
                'background-color: #FFE53B;background-image: linear-gradient(147deg, #FFE53B 0%, #FF2525 74%);',
                'background-color: #08AEEA;background-image: linear-gradient(0deg, #08AEEA 0%, #2AF598 100%);',
                'background-color: #FAACA8;background-image: linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%);',
                'background-color: #FF9A8B;background-image: linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%);',
                'background-color: #4158D0;background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);',
                'background-color: #0cbaba;background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);'
            ]
        }
    },

    props: {
        title: String
    },

    created(){
        document.addEventListener('keyup', (e) => {
            if(e.keyCode === 27){
                this.close()
            }
        })
    },

    methods: {
        open(){
            this.modal = true
            this.$emit('open')
        },
        close(){
            this.modal = false
            this.$emit('close')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/Modal.vue